import React, { useEffect, useState } from "react";
import StudentDetailsForm from "./StudentDetailsForm";
import StudentDocumentUpload from "../../StudentTransfersWorkFlow/StudentDocumentUpload";
import PaymentForm from "../../Payment/Payment";
import StudentPreview from "./StudentPreview";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import { InfoAlert } from "../../CommonUtils/SweetAlerts";
import PaymentReceipt from "../../Payment/PaymentReceipt";

const StudentCompletionTabs = () => {
    const [activeTab, setActiveTab] = useState(1);
    const userId = sessionStorage.getItem("user_id");
    const [confirmStatus, setConfirmStatus] = useState([]);
    const [paymentReceiptData, setPaymentReceiptData] = useState([]);

    function GetstudentPaymentReceiptData() {
        CommonAxiosGet(config.url.STU_URL + "paymentDetails/" + userId).then(res => {
            if (res?.data?.status === true) {
                setPaymentReceiptData(res?.data?.scode === "01" ? res.data?.paymentDetails?.[0] : []);
            }
            else {
                setPaymentReceiptData([]);
            }
        })
    }

    function GetstudentConfimationStatus() {
        CommonAxiosGet(config.url.STU_URL + "getStudentConfirmStatus")
            .then(res => {
                if (res?.data?.status === true) {

                    const data =
                        res?.data?.scode === "01"
                            ? res.data.data[0]
                            : {};

                    setConfirmStatus([data]);

                    // Auto-open next pending step
                    if (data?.stu_profile !== 1) {
                        setActiveTab(1);
                    }
                    else if (data?.stu_doc_upload !== 1) {
                        setActiveTab(2);
                    }
                    else if (data?.stu_payment !== 1) {
                        setActiveTab(3);
                    }
                    else {
                        setActiveTab(4);
                    }
                }
            });
    }
    const statusData = confirmStatus?.[0] || {};



    const handleTabChange = (tabId) => {
        // Student Details must be completed first
        if (statusData?.stu_profile !== 1) {
            if (tabId !== 1) {
                InfoAlert("Please complete Student Details first");
                return;
            }
        }

        // Document Upload must be completed before Payment
        if (
            statusData?.stu_profile === 1 &&
            statusData?.stu_doc_upload !== 1
        ) {
            if (tabId > 2) {
                InfoAlert("Please complete Document Upload first");
                return;
            }
        }

        // Payment must be completed before further tabs (if any)
        if (
            statusData?.stu_profile === 1 &&
            statusData?.stu_doc_upload === 1 &&
            statusData?.stu_payment !== 1
        ) {
            if (tabId > 3) {
                InfoAlert("Please complete Payment first");
                return;
            }
        }

        setActiveTab(tabId);
    };
    useEffect(() => { GetstudentConfimationStatus(); GetstudentPaymentReceiptData(); }, []);
    const tabs = [
        {
            id: 1,
            label: "Student Details",
            component: <StudentDetailsForm refreshStatus={GetstudentConfimationStatus} paymentFlag={statusData?.stu_payment === 1} />
        },
        {
            id: 2,
            label: "Document Upload",
            component: <StudentDocumentUpload refreshStatus={GetstudentConfimationStatus} paymentFlag={statusData?.stu_payment === 1} />
        },
        // {
        //     id: 3,
        //     label: "Payment",
        //     component: <PaymentForm   refreshStatus={GetstudentConfimationStatus}/>
        // },
        {
            id: 3,
            label: "Payment",
            component:
                statusData?.stu_payment === 1
                    ? <PaymentReceipt paymentData={paymentReceiptData} />
                    : <PaymentForm refreshStatus={GetstudentConfimationStatus} />
        },
        {
            id: 4,
            label: "Preview",
            component: <StudentPreview studentRegNo={userId} />
        }
    ];

    return (
        <>


            <div
                style={{
                    width: "100%",
                    padding: "20px",
                    background: "#fff",
                    borderRadius: "10px"
                }}
            >
                {/* STEP TABS */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        overflow: "hidden",
                        borderRadius: "8px",
                        border: "1px solid #cbd5e1",
                        background: "#f8fafc"
                    }}
                >
                    {tabs.map((tab, index) => {
                        const isActive = activeTab === tab.id;
                        const isCompleted = activeTab > tab.id;
                        const isDisabled =
                            (tab.id === 2 && statusData?.stu_profile !== 1) ||
                            (tab.id === 3 && statusData?.stu_doc_upload !== 1) ||
                            (tab.id === 4 && statusData?.stu_payment !== 1);
                        return (

                            <div
                                key={tab.id}
                                // onClick={() => setActiveTab(tab.id)}
                                onKeyDown={(e) => {
                                    if (!isDisabled && (e.key === "Enter" || e.key === " ")) {
                                        handleTabChange(tab.id);
                                    }
                                }}
                                role="button"
                                onClick={() => handleTabChange(tab.id)}
                                style={{
                                    position: "relative",
                                    flex: 1,
                                    height: "48px",
                                    display: "flex",
                                    alignItems: "center",
                                    // cursor: "pointer",
                                    cursor: isDisabled ? "not-allowed" : "pointer",
                                    opacity: isDisabled ? 0.6 : 1,
                                    background:
                                        isActive || isCompleted
                                            ? "#005b96"
                                            : "#f8fafc",

                                    color:
                                        isActive || isCompleted
                                            ? "#fff"
                                            : "#1e293b",

                                    paddingLeft:
                                        index === 0 ? "18px" : "34px",

                                    paddingRight: "20px",

                                    fontWeight: 600,
                                    fontSize: "14px",

                                    clipPath:
                                        index === 0
                                            ? "polygon(0 0,92% 0,100% 50%,92% 100%,0 100%)"
                                            : index === tabs.length - 1
                                                ? "polygon(0 0,100% 0,100% 100%,0 100%,8% 50%)"
                                                : "polygon(0 0,92% 0,100% 50%,92% 100%,0 100%,8% 50%)",

                                    marginLeft:
                                        index === 0 ? "0" : "-12px",

                                    zIndex: tabs.length - index,

                                    transition: "all .3s ease"
                                }}
                            >
                                {/* STEP NUMBER */}
                                <div
                                    style={{
                                        width: "24px",
                                        height: "24px",
                                        borderRadius: "50%",
                                        background:
                                            isActive || isCompleted
                                                ? "rgba(255,255,255,0.2)"
                                                : "#d1d5db",

                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",

                                        fontSize: "12px",
                                        fontWeight: "700",

                                        marginRight: "10px",

                                        flexShrink: 0
                                    }}
                                >
                                    {isCompleted ? "✓" : tab.id}
                                </div>

                                {/* LABEL */}
                                <span
                                    style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}
                                >
                                    {tab.label}
                                </span>
                            </div>
                        );
                    })}
                </div>

                {/* STEP INFO */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "18px",
                        marginBottom: "8px",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#334155"
                    }}
                >
                    <span>
                        Step {activeTab} of {tabs.length} —{" "}
                        {tabs.find((t) => t.id === activeTab)?.label}
                    </span>

                    <span>
                        {Math.round(
                            (activeTab / tabs.length) * 100
                        )}
                        %
                    </span>
                </div>

                {/* PROGRESS BAR */}
                <div
                    style={{
                        width: "100%",
                        height: "6px",
                        background: "#dbeafe",
                        borderRadius: "10px",
                        overflow: "hidden"
                    }}
                >
                    <div
                        style={{
                            width: `${(activeTab / tabs.length) * 100}%`,
                            height: "100%",
                            background: "#005b96",
                            transition: "0.3s ease"
                        }}
                    />
                </div>

                {/* TAB CONTENT */}
                <div
                    style={{
                        marginTop: "24px",
                        background: "#fff",
                        border: "1px solid #e2e8f0",
                        borderRadius: "14px",
                        padding: "24px",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.05)"
                    }}
                >
                    {tabs.find((t) => t.id === activeTab)?.component}
                </div>
            </div>
        </>
    );
};

export default StudentCompletionTabs;